import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { GUIDES, GALLERY } from "../data/content";

const Guides = () => (
  <main data-testid="guides-page" className="bg-brand-bone">
    <Seo
      title="Mortgage & Protection Guides"
      description="Short, honest reads on the moves that matter — first-time buyer roadmap, remortgaging, buy-to-let basics and family protection."
      path="/resources/guides"
      image={GALLERY[3]}
    />
    <PageHero
      testId="guides-hero"
      eyebrow="Resources · Guides"
      title="Guides,"
      italic="minus the waffle."
      intro="Short, honest reads on the moves that matter — written the way we'd explain it over a coffee."
      image={GALLERY[3]}
    />

    <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="space-y-16">
        {GUIDES.map((g, i) => (
          <Reveal key={g.title} delay={0.05}>
            <article data-testid={`guide-${i}`} className="border border-black/10 bg-white p-10 sm:p-14">
              <div className="flex flex-wrap items-center gap-4">
                <span className="text-[0.68rem] font-semibold uppercase tracking-[0.3em] text-brand">Guide {String(i + 1).padStart(2, "0")}</span>
                <span aria-hidden className="h-px w-10 bg-brand/40" />
                <span className="inline-flex items-center gap-1.5 text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-neutral-500">
                  <Clock size={13} weight="duotone" />
                  {g.minutes} min read
                </span>
              </div>
              <h2 className="editorial-h mt-6 text-3xl text-brand-ink sm:text-4xl">
                {g.title}
              </h2>
              <p className="mt-5 text-lg font-medium leading-snug text-brand-ink/70">{g.summary}</p>
              {g.body.map((p, j) => (
                <p key={j} className="mt-6 text-sm leading-relaxed text-neutral-600 sm:text-base">
                  {p}
                </p>
              ))}
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <div className="relative mt-20 overflow-hidden bg-brand-ink p-10 sm:p-14">
          <img aria-hidden src={GALLERY[0]} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/90 to-brand-ink/70" />
          <div className="relative">
            <p className="eyebrow text-brand-gold"><span className="rule-line" />Prefer talking?</p>
            <h2 className="editorial-h mt-6 text-3xl text-white sm:text-4xl">
              Prefer the <span className="italic text-brand-gold">two-minute</span> version?
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70">
              A call with us covers your exact situation — no reading required.
            </p>
            <Link
              to="/contact"
              data-testid="guides-cta-btn"
              className="group mt-8 inline-flex items-center gap-2 bg-brand px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
            >
              Book a call
              <ArrowRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  </main>
);

export default Guides;
